import React from "react";
import {withStyles} from '@material-ui/core/styles';

const ToolbarLogo = ({href, src, classes}) => (
    <a
        className={classes.logo}
        href={href}
    >
        <img
            className={classes.logoImage}
            src={src}
        />
    </a>
);

const styles = theme => ({
    logo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    logoImage: {
        height: '40px',
    },
});

export default withStyles(styles)(ToolbarLogo);